export const TestIds = {
  root: 'imageX',
  scrollEffectStyle: 'scrollEffectStyle',
  displayModeStyle: 'displayModeStyle',
};

export const COMP_SELECTOR_PLACEHOLDER = '#<%= compId %>';
